import { Inject, Injectable } from "@angular/core";
import { LIB_ENVIRONMENT } from "./environment.token";
import { HttpClient } from "@angular/common/http";
import { CommonLibraryEnvironment, LookupDto, LookupType } from "./models";
import { Observable } from "rxjs";

@Injectable({
    providedIn: "root",
  })
  /**
   * API client for Loans API reference-data lookups (genders, banks,
   * provinces, etc.) used to populate dropdowns across the backoffice UI.
   */
  export class LookupService {
    /** Base URL of the lookups endpoint for the configured environment. */
    get baseurl(): string {
      return this.env.apiUrl + "/api/v1/lookups";
    }
  
    constructor(
      @Inject(LIB_ENVIRONMENT) private env: CommonLibraryEnvironment,
      private httpClient: HttpClient,
    ) {}
  
    /**
     * Fetches the reference-data list for a lookup category.
     * @param type The lookup category to retrieve.
     */
    public getLookups(type: LookupType): Observable<LookupDto[]> {
      return this.httpClient.get<LookupDto[]>(`${this.baseurl}/${type}`);
    }

  }
  